import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { Button } from './Button';

interface ThemeToggleProps {
  className?: string;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '' }) => {
  const { resolvedTheme, toggleTheme } = useTheme();

  return (
    <Button
      type="button"
      variant="secondary"
      size="icon-xs"
      onClick={toggleTheme}
      className={className}
      title={resolvedTheme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      aria-label="Toggle theme"
    >
      {resolvedTheme === 'dark' ? (
        <Sun size={14} className="text-cf-textSecondary hover:text-cf-textPrimary transition-transform rotate-0 scale-100" />
      ) : (
        <Moon size={14} className="text-cf-textSecondary hover:text-cf-textPrimary transition-transform rotate-0 scale-100" />
      )}
    </Button>
  );
};
